<script setup lang="ts">
/**
 * UI-kit component
 * Category: Typography
 * Name: 'Body 2/Regular'
 * FIGMA: 'https://www.figma.com/design/CFyOwQUjj7uVRQTc03muvG/Demo-CS?node-id=216-126911&m=dev'
*/

defineOptions({
  name: 'TextSecondary',
})

withDefaults(defineProps<TextSecondaryProps>(), {
  is: 'div',
})

interface TextSecondaryProps {
  is?: 'div' | 'p' | 'span'
}
</script>

<template>
  <component
    :is="is"
    class="p-text-secondary"
  >
    <slot />
  </component>
</template>

<style scoped lang="scss" src="@scss/components/UI/Typography/TextSecondary.scss" />
